"use client";

import { useEffect, useState } from "react";

export default function LogoutPage() {
  const [status, setStatus] = useState<string>("Logging out...");

  useEffect(() => {
    const logout = async () => {
      try {
        const response = await fetch("/api/logout", {
          method: "GET",
        });

        if (response.ok) {
          setStatus("Logged out successfully");
        } else {
          setStatus(`Logout failed: ${response.status}`);
        }
      } catch (error) {
        setStatus(`Logout error: ${error}`);
      }
    };

    logout();
  }, []);

  return (
    <main style={{ padding: 24, fontFamily: "system-ui" }}>
      <h1>Logout</h1>
      <p>{status}</p>
    </main>
  );
}
